<template>
    <div>
        <q-table
            :data="data"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-md"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="move" :props="props">
                    <q-btn flat round color="primary" icon="far fa-arrow-up" @click="moveItem(props, 'up')" :disable="!managePodcasts" />
                    <q-btn flat round color="negative" icon="far fa-arrow-down" @click="moveItem(props, 'down')" :disable="!managePodcasts" />
                </q-td>

                <q-td key="hierarchy_order" :props="props">
                    {{ props.row.hierarchy_order }}
                    <!-- <q-popup-edit v-model="props.row.hierarchy_order" @hide="reorderItems(props.row)">
                        <q-input v-model="new_order" type="number" />
                    </q-popup-edit> -->
                </q-td>

                <q-td key="audio_title" :props="props">
                    {{ props.row.audio_title }}
                </q-td>

                <q-td key="audio_duration" :props="props">
                    {{ props.row.audio_duration }}
                </q-td>

                <q-td auto-width key="audio_status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.audio_status)" :color="getColorStatus(props.row.audio_status)" class="full-width">
                        {{ $t(getStatus(props.row.audio_status)) }}
                    </q-chip>
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'admin_podcasts' })" />
            </div>

            <div class="col-xs-12 col-sm-3">
                <q-btn color="negative" class="full-width" :label="$t('unpublish')" icon="far fa-ban" @click="unpublish()" :disable="disableButtons || !managePodcasts">
                    <q-tooltip v-if="disableButtons">
                        {{ $t('no_audios_on_podcast') }}
                    </q-tooltip>
                </q-btn>
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="positive" class="full-width" :label="$t('publish')" icon="far fa-upload" @click="publish()" :disable="disableButtons || !managePodcasts">
                    <q-tooltip v-if="disableButtons">
                        {{ $t('no_audios_on_podcast') }}
                    </q-tooltip>
                </q-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { debounce } from 'quasar'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: [ 'managePodcasts' ],

    data() {
        return {
            id: '',
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'hierarchy_order'
            },
            data: [],
            columns: [
                {
                    name: 'move',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'move',
                    sortable: false,
                },
                {
                    name: 'hierarchy_order',
                    required: true,
                    label: 'order',
                    align: 'left',
                    field: 'hierarchy_order',
                    sortable: false,
                },
                {
                    name: 'audio_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'audio_title',
                    sortable: false,
                },
                {
                    name: 'audio_duration',
                    required: true,
                    label: 'duration',
                    align: 'left',
                    field: 'audio_duration',
                    sortable: false,
                },
                {
                    name: 'audio_status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'audio_status',
                    sortable: false,
                },
            ],
            loading: false,
            new_order: '',
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        disableButtons() {
            if (this.data.length == 0) return true
            else return false
        }
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get(`/admin_podcast/podcasts/${this.id}/podcasts_hierarchy/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.data = response.data.map(e => {
                    return {
                        ...e,
                        move: e.audio_id
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        saveConfigure() {
            this.$axios.post(`/admin_podcast/podcasts/${this.id}/podcasts_hierarchy/`, this.data, this.getHeader)
            .then(response => {
                this.data = response.data.map(e => {
                    return {
                        ...e,
                        move: e.audio_id
                    }
                })

                this.$q.notify({
                    message: this.$t('configure_edit_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })
            })
            .catch(e => {
                console.log(e)
            })
        },

        publish() {
            this.$q.loading.show()

            let fd = new FormData()

            this.$axios.post(`/admin_podcast/podcasts/${this.id}/publish/`, fd, this.getHeader)
            .then(response => {
                this.$q.loading.hide()
                this.$router.push({ name: 'admin_podcasts' })
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        unpublish() {
            this.$q.loading.show()

            let fd = new FormData()

            this.$axios.post(`/admin_podcast/podcasts/${this.id}/unpublish/`, fd, this.getHeader)
            .then(response => {
                this.$q.loading.hide()
                this.$router.push({ name: 'admin_podcasts' })
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        getIconName(slug) {
            if (slug == 'module') return 'fal fa-clipboard-list-check'
            else if (slug == 'test') return 'fal fa-chalkboard-teacher'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        moveItem(item, direction) {
            if (direction == 'up' && item.row.hierarchy_order > 1) item.row.hierarchy_order--
            else if (direction == 'down' && item.row.hierarchy_order < this.data.length) item.row.hierarchy_order++

            let obj = this.data.find((obj) => { return obj.move !== item.row.move && obj.hierarchy_order === item.row.hierarchy_order })

            if (obj) {
                if (direction == 'up') {
                    obj.hierarchy_order++
                }
                if (direction == 'down') {
                    obj.hierarchy_order--
                }
            }

            this.saveConfigure()
        },

        reorderItems(row) {
            if (this.new_order > 0 && this.new_order <= this.data.length) {
                if (row.hierarchy_order > this.new_order) {
                    this.data.forEach(data => {
                        if (data.move != row.move && data.hierarchy_order < row.hierarchy_order && data.hierarchy_order >= this.new_order) {
                            if ((data.hierarchy_order + 1) <= this.data.length) data.order++
                        }
                    })
                }
                else if (row.hierarchy_order < this.new_order) {
                    this.data.forEach(data => {
                        if (data.move != row.move && data.hierarchy_order > row.hierarchy_order && data.hierarchy_order <= this.new_order) {
                            if ((data.hierarchy_order - 1) > 0) data.hierarchy_order--
                        }
                    })
                }

                row.hierarchy_order = this.new_order
                this.saveConfigure()
            }
            this.new_order = ''
        },

        getStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },
    },

    created() {
        this.id = this.$route.params.id

        this.request({
            pagination: this.server_pagination
        })
    }
}
</script>

<style lang="stylus" scoped>

</style>
